import { render } from "./StickerJS.vue?vue&type=template&id=f32d3c18&scoped=true"
import script from "./StickerJS.js?vue&type=script&lang=js&external"
export * from "./StickerJS.js?vue&type=script&lang=js&external"

import "./StickerJS.css?vue&type=style&index=0&id=f32d3c18&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f32d3c18"]])

export default __exports__